(function() { module.exports = window["wp"]["blockEditor"]; }());